import React, { FC, useCallback } from 'react'
import { useHistory, useLocation } from 'react-router-dom'
import { Grid, IconButton } from '@mui/material'
import { Theme } from '@mui/material/styles'
import { makeStyles } from '@mui/styles'
import ArrowBack from '@mui/icons-material/ArrowBack'
import ArrowForward from '@mui/icons-material/ArrowForward'

interface IProps {
  title?: string
  leftArrow?: boolean
  rightArrow?: boolean
  activeStep: number
  isValid?: boolean
}

const useStyles = makeStyles((theme: Theme) => ({
  container: {
    position: 'relative',
    paddingTop: 96,
  },
  title: {
    fontFamily: 'Montserrat, sans-serif',
    fontSize: 40,
    fontWeight: 'bold',
    lineHeight: '56px',
    color: theme.palette.primary.dark,
  },
  arrowLeft: {
    position: 'absolute',
    left: 0,
    opacity: 0.6,
    cursor: 'pointer',
    '&:hover': {
      opacity: 1,
    },
  },
  arrowRight: {
    position: 'absolute',
    right: 0,
    // opacity: 0.6,
    cursor: 'pointer',
    '&:hover': {
      // opacity: 1,
    },
  },
}))

export const TitleOnBoarding: FC<IProps> = ({ title, leftArrow, rightArrow, activeStep, isValid }) => {
  const classes = useStyles()
  const history = useHistory()
  const location = useLocation()

  const nextStep = useCallback(() => {
    history.push({
      ...location,
      state: {
        activeStep,
      },
    })
  }, [activeStep, history, location])

  const previousStep = useCallback(() => {
    history.goBack()
  }, [history])

  return (
    <Grid className={classes.container} container justifyContent={'center'} alignItems={'center'}>
      {leftArrow && (
        <Grid className={classes.arrowLeft}>
          <IconButton onClick={previousStep}>
            <ArrowBack />
          </IconButton>
        </Grid>
      )}
      <Grid item className={classes.title}>
        {title}
      </Grid>
      {rightArrow && (
        <Grid className={classes.arrowRight}>
          <IconButton disabled={!isValid} onClick={nextStep}>
            <ArrowForward />
          </IconButton>
        </Grid>
      )}
    </Grid>
  )
}
